import React, { useState, useEffect } from 'react';

// Moment
import moment from 'moment';

// Notistack
import { useSnackbar } from 'notistack';

// Material-UI
import { Dialog, DialogContent, DialogActions, Divider, Button, Grid } from '@material-ui/core';

// Services
import { updateRefund, deleteRefund } from 'services/requests';
import { amountToSend, amountToBeReceived, isValidAmount } from 'services/helpers';

// Components
import Spinner from 'components/spinner';

// Messages
import messages from 'messages.json';

// Views
import RefundForm from './refunds-form';

// ----------------------------------------------------------------------------------------------- \\
// ---------------------------------------- UPDATE REFUND ---------------------------------------- \\
// ----------------------------------------------------------------------------------------------- \\

const UpdateRefund = ({ onClose, refetch, refund }) => {
    const { enqueueSnackbar } = useSnackbar();

    const [state, setState] = useState({
        loading: false,
        refund_date: refund.refund_date || null,
        amount: amountToBeReceived(refund.amount),
        reference: refund.reference || '',
        payment_method: refund.payment_method || -1,
        status: refund.status || -1,

        // Delete
        openDelete: false,
    });

    function onUpdate() {
        if (state.payment_method === -1 || state.status === -1) {
            enqueueSnackbar(messages['fields.required'], { variant: 'warning' });
        }
        else if (!isValidAmount(state.amount)) {
            enqueueSnackbar('Veuillez saisir un montant valide', { variant: 'warning' });
        }
        else {
            setState({ ...state, loading: true });
        }
    }

    function onRefetchDelete() {
        setState({ ...state, openDelete: false });
        refetch();
    }

    useEffect(() => {
        if (state.loading) {
            updateRefund(refund.id, {
                refund_date: state.refund_date ? moment(state.refund_date).format('YYYY-MM-DD') : null,
                amount: amountToSend(state.amount),
                reference: state.reference,
                payment_method: state.payment_method,
                status: state.status,
            }).then(res => {
                if (res.status === 200) {
                    enqueueSnackbar(res.data.message, { variant: 'success' });
                    refetch();
                }
                else {
                    enqueueSnackbar(res, { variant: 'error' });
                    setState({ ...state, loading: false });
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.loading]);

    return (
        <>
            <Dialog open fullWidth>
                {state.loading ? (
                    <Spinner />
                ) : (
                    <>
                        <DialogContent style={{ paddingBottom: 20 }}>
                            <p className="dialog-title">
                                Modifier le remboursement
                            </p>
                            <RefundForm
                                state={state}
                                setState={setState}
                            />
                            {/* -------------------- DELETE -------------------- */}
                            <Divider style={{ margin: '15px 0px' }} />
                            <Grid container alignItems="center" style={{ marginTop: 5 }}>
                                <Grid item xs={12} sm={4}>
                                    Supprimer
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <Button
                                        onClick={() => setState({ ...state, openDelete: true })}
                                        variant="contained" color="secondary"
                                    >
                                        Supprimer
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <Divider />
                        <DialogActions style={{ justifyContent: 'space-between' }}>
                            <Button onClick={onClose} variant="contained">
                                Annuler
                            </Button>
                            <Button onClick={onUpdate} variant="contained">
                                Enregistrer
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>
            {/* -------------------- DELETE REFUND -------------------- */}
            {state.openDelete && (
                <DeleteRefund
                    onClose={() => setState({ ...state, openDelete: false })}
                    refetch={() => onRefetchDelete()}
                    refund={refund}
                />
            )}
        </>
    );
};

// ----------------------------------------------------------------------------------------------- \\
// ---------------------------------------- DELETE REFUND ---------------------------------------- \\
// ----------------------------------------------------------------------------------------------- \\

const DeleteRefund = ({ onClose, refetch, refund }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (loading) {
            deleteRefund(refund.id).then(res => {
                if (res.status === 200) {
                    enqueueSnackbar(res.data.message, { variant: 'success' });
                    refetch();
                }
                else {
                    enqueueSnackbar(res, { variant: 'error' });
                    setLoading(false);
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading]);

    return (
        <Dialog open>
            {loading ? (
                <Spinner />
            ) : (
                <>
                    <DialogContent style={{ paddingBottom: 20 }}>
                        <p className="dialog-title">
                            Remboursement #{refund.reference}
                        </p>
                        Êtes-vous sûr de vouloir supprimer ce remboursement ?
                    </DialogContent>
                    <Divider />
                    <DialogActions style={{ justifyContent: 'space-between' }}>
                        <Button onClick={onClose} variant="contained">
                            Non
                        </Button>
                        <Button onClick={() => setLoading(true)} variant="contained">
                            Oui
                        </Button>
                    </DialogActions>
                </>
            )}
        </Dialog>
    );
};

export default UpdateRefund;
